import React from "react";
import {Col, Row, Typography} from "antd";
import PropTypes from "prop-types";

import {getTransactionType} from "../../../helpers/billing";

const NontaxableTransactionBreakdown = ({transaction}) => {
    const type = getTransactionType(transaction);
    const referenceText = type === 'Usage Credit' ? 'Booking #:' : 'Reference #:';
    let referenceNumber;

    if (type === 'Usage Credit') {
        referenceNumber = transaction.transactable.booking_numbers.length > 0 ? transaction.transactable.booking_numbers.join(', ') : '';
    } else {
        referenceNumber = (transaction.transactable.reference || transaction.transactable.number);
    }

    const promotionName = transaction.transactable.promotion_name;

    return <>
        <Row justify="start">
            <Col><Typography.Text strong>{referenceText}</Typography.Text></Col>
            <Col>
                <span className="long-text-wrap ref-num">{referenceNumber ? referenceNumber : 'N/A'}</span>
            </Col>
        </Row>
        {type === 'Usage Credit' &&
            <Row justify="start">
                <Col><Typography.Text strong>Promotion:</Typography.Text></Col>
                <Col>
                    <span className="long-text-wrap ref-num">{promotionName}</span>
                </Col>
            </Row>
        }
    </>
};

export default NontaxableTransactionBreakdown;

NontaxableTransactionBreakdown.propTypes = {
    transaction: PropTypes.shape({
        transactable: PropTypes.object.isRequired,
        amount: PropTypes.string.isRequired,
    }).isRequired,
};
